import {
	type ClientPropertyCottageDetailResponseDTO,
	type ClientPropertyFlatDetailResponseDTO,
	type ClientPropertyHouseDetailResponseDTO,
	ClientPropertyTypeEnum,
} from "web_myplann/Infrastructure/Api/Api";
import { EditCottageForm } from "web_myplann/Portfolio/Pages/RealEstateEdit/EditCottageForm";
import { EditFlatForm } from "web_myplann/Portfolio/Pages/RealEstateEdit/EditFlatForm";
import { EditHouseForm } from "web_myplann/Portfolio/Pages/RealEstateEdit/EditHouseForm";

export type BuildingPropertyDetail =
	| ClientPropertyFlatDetailResponseDTO
	| ClientPropertyHouseDetailResponseDTO
	| ClientPropertyCottageDetailResponseDTO;

type EditRealEstateFormProps = {
	propertyId: number;
	property: BuildingPropertyDetail;
	detailRoute: string;
};

const isFlat = (
	property: BuildingPropertyDetail,
): property is ClientPropertyFlatDetailResponseDTO =>
	property.type === ClientPropertyTypeEnum.Flat;

const isHouse = (
	property: BuildingPropertyDetail,
): property is ClientPropertyHouseDetailResponseDTO =>
	property.type === ClientPropertyTypeEnum.House;

export const EditRealEstateForm = ({
	propertyId,
	property,
	detailRoute,
}: EditRealEstateFormProps) => {
	const sharedProps = { propertyId, detailRoute };

	if (isFlat(property)) {
		return <EditFlatForm {...sharedProps} property={property} />;
	}

	if (isHouse(property)) {
		return <EditHouseForm {...sharedProps} property={property} />;
	}

	return <EditCottageForm {...sharedProps} property={property} />;
};
